import { generateUUID } from '@/app/lib/Functions/uuids';
import { dispatchExtensionEvent } from '@/app/lib/Functions/extension';
import MessageType from 'wdm-common/Messaging/MessageType';

/**
 * @type {Object.<string, {resolve: function, reject: function}>}
 */
const pendingRequests = {};

/**
 *
 * @param {string} requestType
 * @param {{}} requestPayload
 *
 * @return {Promise}
 */
export const sendBackendRequest = (requestType, requestPayload = {}) => {
    return new Promise((resolve, reject) => {
        const requestId = generateUUID();

        dispatchExtensionEvent(MessageType.REQUEST, {
            requestId,
            requestType,
            requestPayload,
        });

        // Add the resolve function the array of pending requests.
        pendingRequests[requestId] = {
            resolve,
            reject,
        };
    });
};

export const initResponseListener = () => {
    document.addEventListener(MessageType.RESPONSE, (event) => {
        const dtl = event.detail;
        console.log('response', event.detail);

        if (dtl.requestId && pendingRequests[dtl.requestId]) {
            if (dtl.errorMessage) {
                pendingRequests[dtl.requestId].reject(dtl);
            } else {
                pendingRequests[dtl.requestId].resolve(dtl.responsePayload || {});
            }
        }
    });
};
